import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'

import { httpOk, GET, POST, PUT } from 'helpers/api'
import { formatDate } from "helpers/helpers"
import { SketchPicker } from "react-color"

function Index() {
	const { t } = useTranslation()

	const colorRef = useRef(null);

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function searchWithFilter() {
		var filterUrl = "/product-group-statuses"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/product-group-statuses', selectedItem, { loader: true })
		} else {
			response = await POST('/product-group-statuses', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal(false)
			searchWithFilter()
		}
	}

	function toggleModal(bool, item = {}) {
		if (bool) setSelectedItem(item)

		setShowModal(bool)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('product_statuses')} [{data.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }}>{t('color')}</th>
									<th style={{ 'width': '20%' }}>{t('order2')}</th>
									<th style={{ 'width': '10%' }}>{t('default')}</th>
									<th style={{ 'width': '40%' }}></th>
									<th style={{ 'width': '8%' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>
											<div className="d-flex align-items-center gap-2">
												<div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: item.color }} />
												{item.color}
											</div>
										</td>
										<td>{item.order_number}</td>
										<td>{item.default ? t('yes') : t('no')}</td>
										<td></td>
										<td className="text-center">{formatDate(item.created_at)}</td>

										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<div className="position-relative">
								<label>{t('color')}</label>
								<input
									type="text"
									className="form-control"
									value={selectedItem.color}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'color': e.target.value })}
									onFocus={() => setSelectedItem({ ...selectedItem, 'color_bool': true })}
									onBlur={() => setSelectedItem({ ...selectedItem, 'color_bool': false })}
								/>
								{/* <div className="color-picker-icon" style={{ backgroundColor: selectedItem.color }}
									onClick={() => setSelectedItem({ ...selectedItem, 'color_bool': !selectedItem.color_bool })}
								/> */}
							</div>
							{selectedItem.color_bool &&
								<div ref={colorRef}>
									<SketchPicker
										className="color-picker-body"
										onChangeComplete={(color) => setSelectedItem({ ...selectedItem, color: color.hex })}
										color={selectedItem.color}
									/>
								</div>
							}
						</div>

						<div className="form-group">
							<label>{t('order2')}</label>
							<input type="text" className="form-control" name="order_number"
								value={selectedItem.order_number ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'order_number': e.target.value })} />
						</div>
						<div className="form-check">
							<input id="ofd" className="form-check-input" type="checkbox"
								checked={selectedItem?.default ?? false}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'default': e.target.checked })} />

							<label className="form-check-label" htmlFor="ofd">
								{t('default')}
							</label>
						</div>


						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index